import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  Product,
  ProductBenefit,
  ProductAdditionalInfo,
  ProductEligibility,
  ProductPremium,
  Pagination,
} from "services/insuranceService";

interface InsuranceState {
  productList: {
    products: Product[];
    pagination?: Pagination;
  } | null;

  singleProduct: Product | null;

  benefitList: ProductBenefit[];
  additionalInfo: ProductAdditionalInfo | {};
  eligibilityList: ProductEligibility[];
  premiumList: ProductPremium | {};

  successMsg: { message: string; id: string | number };
  errorMsg: { message: string; id: string | number };

  loading: boolean;
  pagination: Pagination | {};
}

const initialState: InsuranceState = {
  productList: null,
  singleProduct: null,

  benefitList: [],
  additionalInfo: {},
  eligibilityList: [],
  premiumList: {},

  successMsg: { message: "", id: "" },
  errorMsg: { message: "", id: "" },

  loading: false,
  pagination: {},
};

const insuranceSlice = createSlice({
  name: "insurance",
  initialState,
  reducers: {
   fetchProducts(state, action: PayloadAction<any>) {
  state.productList = {
    products: action.payload?.products || [],  // ✔ FIXED
    pagination: action.payload?.pagination || {},
  };
},

    fetchSingleProduct(state, action: PayloadAction<Product | null>) {
      state.singleProduct = action.payload;
    },
    fetchBenefits(state, action: PayloadAction<ProductBenefit[]>) {
      state.benefitList = action.payload || [];
    },
    fetchAdditionalInfo(state, action: PayloadAction<ProductAdditionalInfo | {}>) {
      state.additionalInfo = action.payload || {};
    },
    fetchEligibility(state, action: PayloadAction<ProductEligibility[]>) {
      state.eligibilityList = action.payload || [];
    },
    fetchPremium(state, action: PayloadAction<ProductPremium | {}>) {
      state.premiumList = action.payload || {};
    },
    setPagination(state, action: PayloadAction<Pagination | {}>) {
      state.pagination = action.payload || {};
    },
    successMsg(state, action) {
      state.successMsg = action.payload;
    },
    errorMsg(state, action) {
      state.errorMsg = action.payload;
    },
    setLoader(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
  },
});

export const {
  fetchProducts,
  fetchSingleProduct,
  fetchBenefits,
  fetchAdditionalInfo,
  fetchEligibility,
  fetchPremium,
  setPagination,
  successMsg,
  errorMsg,
  setLoader,
} = insuranceSlice.actions;

export default insuranceSlice.reducer;
